
import { defineComponent, inject, ref } from "vue"
export default defineComponent({
    setup(){
        const serverFile = ref(process.env.VUE_APP_API_URL)
        const urlFile = inject('urlFile')
        const open_dialog_view_file = inject('open_dialog_view_file')

        return {
            serverFile,
            urlFile,
            open_dialog_view_file
        }
    }
    
})
